export default __webpack_public_path__ + "static/media/EllenPantry400.9c4cca75.jpg";